import React from 'react';
import {Document, Page} from 'react-pdf';
import {Box} from '@mui/material';
import HighlightOverlay from '../HighlightOverlay/HighlightOverlay';

function PdfDocumentRenderer({
                                 file,
                                 numPages,
                                 scale,
                                 highlights,
                                 pageRefs,
                                 selectedAnnotations,
                                 onBoxClick,
                                 onBoxHover,
                                 onDocumentLoadSuccess,
                                 isDrawing,
                                 currentRect,
                                 currentPage,
                                 onDissociateAnnotation,
                                 onRemoveAnnotation,
                                 onUpdateAnnotationPosition,
                                 groupingTempKeys,
                                 multiSelectMode,
                                 peekKey,
                                 hoveredKey
                             }) {
    return (
        <Document
            file={file}
            onLoadSuccess={onDocumentLoadSuccess}
            onLoadError={(error) => console.error('Load error:', error)}
        >
            {Array.from(new Array(numPages), (_, index) => {
                const pageNumber = index + 1;
                const pageHighlights = (Array.isArray(highlights) ? highlights : [])
                    .filter(Boolean)
                    .filter(h => Number.isFinite(Number(h.page)) && Number(h.page) === pageNumber);

                return (
                    <Box
                        key={`page_${pageNumber}`}
                        data-index={index}
                        ref={(el) => (pageRefs.current[index] = el)}
                        sx={{
                            position: 'relative',
                            bgcolor: 'white',
                            p: 1,
                            borderRadius: 1,
                            boxShadow: 1,
                            width: 'fit-content',
                            mb: 3,
                        }}
                    >
                        <Page
                            pageNumber={pageNumber}
                            scale={scale}
                            renderAnnotationLayer={false}
                            renderTextLayer={false}
                        />
                        <HighlightOverlay
                            pageHighlights={pageHighlights}
                            scale={scale}
                            onBoxClick={onBoxClick}
                            onBoxHover={onBoxHover}
                            selectedAnnotations={selectedAnnotations}
                            isDrawing={isDrawing}
                            currentRect={currentRect}
                            isCurrentPage={currentPage === index}
                            onDissociateAnnotation={onDissociateAnnotation}
                            onRemoveAnnotation={onRemoveAnnotation}
                            onUpdateAnnotationPosition={onUpdateAnnotationPosition}
                            groupingTempKeys={groupingTempKeys}
                            multiSelectMode={multiSelectMode}
                            peekKey={peekKey}
                            hoveredKey={hoveredKey}
                        />
                    </Box>
                );
            })}
        </Document>
    );
}

export default PdfDocumentRenderer;
